'use client'

import { useAnimationsBase } from '@/hooks'
import { cn } from '@/lib/utils'
import { MEDIA } from '@spot'
import { uniqueId } from 'lodash'
import Link from 'next/link'
import { useRef } from 'react'
import { BaseLinkProps } from '../types'
import generateStyledJsx from './utils/styledJsx'

const BaseLink = ({
  children,
  styled,
  fallback,
  nextLink,
  as = 'a',
  href,
  anim,
  isCurrent,
  animVars,
  animScrollVars,
  isTransition = false,
  onClick,
  ref,
  ...props
}: BaseLinkProps) => {
  //refs
  const tl = useRef<GSAPTimeline | gsap.core.Tween | null>(null)

  //Hooks
  useAnimationsBase({
    ref: ref,
    anim: anim,
    tl,
    animVars: animVars,
    animScrollVars: animScrollVars
  })

  // const { routeTransition } = useNavigation()

  //Handlers
  const handleClick = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    href: string
  ) => {
    // if (isTransition) {
    //   e.preventDefault()
    //   routeTransition(e, href)
    // }
    if (onClick) {
      onClick(e)
    }
  }

  //Styles
  const { desktopStyles, tabletStyles, mobileStyles } =
    generateStyledJsx(styled)

  const id = uniqueId('jsx-')

  const styles =
    // prettier-ignore
    `[data-styled='${id}'] {${desktopStyles}}@media ${MEDIA.tablet} {[data-styled='${id}'] {${tabletStyles}}}@media ${MEDIA.mobile} {[data-styled='${id}'] {${mobileStyles}}}`

  const hasSubpages = props['aria-haspopup'] === 'menu'
  const isButton =
    !href ||
    as === 'button' ||
    (as === 'div' && !href) ||
    (!href && nextLink !== true) ||
    hasSubpages
  const Component = isButton ? fallback || 'button' : nextLink ? Link : as

  const componentProps = {
    ref: ref,
    ...props,
    'data-anim': anim,
    'aria-current': isCurrent ? 'page' : undefined,
    className: cn(props.className, 'global-focus'),
    onClick: (e: any) =>
      isButton ? onClick?.(e) : handleClick(e, href as string),
    ...(isButton ? { type: props?.type || 'button' } : { href })
  }

  if (styled) {
    return (
      <Component data-styled={id} {...componentProps}>
        {children}
        <style jsx>{`
          ${styles}
        `}</style>
      </Component>
    )
  } else {
    return <Component {...componentProps}>{children}</Component>
  }
}

BaseLink.displayName = 'BaseLink'

export default BaseLink
